import PaymentMenu from './PaymentMenu.jsx'

export default PaymentMenu;
